import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './contratoServicoForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';

import { setModoTela, initForm, salvar, excluir, getLista } from './contratoServicoActions';
import { setModoTela as setModoTelaContrato } from '../contrato/contratoActions';

import FormatUtils from '../common/formatUtils/FormatUtils';

class ContratoServico extends Component {

	state = {
		linhaSelecionada: null
	}

	componentDidMount() {

	}

    componentWillMount() {
		this.props.getLista(this.props.id_contrato);
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form id_hospital={this.props.id_hospital} onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form id_hospital={this.props.id_hospital} excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		let lista = (this.props.lista).filter(item => {
			if (this.state.pesquisar
				&& !(`${item.nome}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}
			return true;
		});

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ id_contrato: this.props.id_contrato });
								}} />
						</Grid>
						<Grid cols='6 6 4 2'>
							<Button
								text='Voltar'
								type={'warning'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTelaContrato('lista');
									this.props.getLista(0);
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive>
						<THead>
							<Tr>
								<Th>Nome</Th>
								<Th alignRight>Valor Unitário</Th>
								<Th alignRight>Valor Mensal</Th>
								<Th alignRight>Perc. Imposto</Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{item.nome}</Td>
									<Td alignRight>{FormatUtils.formatarValorTela(item.valor_unitario, 2)}</Td>
									<Td alignRight>{FormatUtils.formatarValorTela(item.valor_mensal, 2)}</Td>
									<Td alignRight>{FormatUtils.formatarValorTela(item.percentual_imposto, 2)}</Td>
									<Td alignRight minWidth={10}>																			
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													valor_unitario: FormatUtils.formatarValorTela(item.valor_unitario, 2),
													valor_mensal: FormatUtils.formatarValorTela(item.valor_mensal, 2),
													percentual_imposto: FormatUtils.formatarValorTela(item.percentual_imposto, 2)
												});
												this.props.initForm({
													...item,
													valor_unitario: FormatUtils.formatarValorTela(item.valor_unitario, 2),
													valor_mensal: FormatUtils.formatarValorTela(item.valor_mensal, 2),
													percentual_imposto: FormatUtils.formatarValorTela(item.percentual_imposto, 2)
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													valor: FormatUtils.formatarValorTela(item.valor, 2),
													valor_plantao: FormatUtils.formatarValorTela(item.valor_plantao, 2),
													percentual_imposto: FormatUtils.formatarValorTela(item.percentual_imposto, 2)
												});
												this.props.initForm({
													...item,
													valor: FormatUtils.formatarValorTela(item.valor, 2),
													valor_plantao: FormatUtils.formatarValorTela(item.valor_plantao, 2),
													percentual_imposto: FormatUtils.formatarValorTela(item.percentual_imposto, 2)
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.contratoServico.modoTela,
	aguardando: state.contratoServico.aguardando,
	lista: state.contratoServico.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista, setModoTelaContrato
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ContratoServico);